<script>
import CourseSalesFilter from "@/components/sale/CourseSalesFilter.vue";
import SalesBase from "./SalesBase.vue";
export default {
  extends: SalesBase,
  data() {
    return {
      filterModal: CourseSalesFilter,
      product_type: "online_course"
    };
  }
};
</script>
